<template>
    <v-dialog :persistent="persistent" :value="value" max-width="500px" @keydown.esc.prevent="cancel">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ $t('show_additional_eo') }}</span>
            </v-card-title>

            <v-card-text>
                <LabelField :label="$t('event_organizer')">
                    <EventOrganizerSelect
                        :show-edit="false"
                        :show-new="false"
                        @selected="onEventOrganizerSelect($event)"
                    />
                </LabelField>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="cancel">{{ $t('cancel') }}</v-btn>
                <v-btn color="action" text :disabled="!selectedEO" @click="confirm">{{ $t('confirm') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts" setup>
import { EventOrganizer } from '@/models/EventOrganizer';
import EventOrganizerSelect from '../event/EventOrganizerSelect.vue';
import { ref, Ref, watch } from 'vue';

const props = defineProps<{
    persistent: boolean;
    value: boolean;
}>();

const emit = defineEmits(['input', 'cancel', 'selected']);

const selectedEO: Ref<EventOrganizer | null> = ref(null);

watch(
    () => props.value,
    (newVal, oldVal) => {
        if (newVal && !oldVal) {
            selectedEO.value = null;
        }
    },
);

function onEventOrganizerSelect(eventOrganizer: EventOrganizer) {
    selectedEO.value = eventOrganizer;
}

function cancel() {
    emit('cancel');
    emit('input', false);
}

function confirm() {
    emit('selected', selectedEO.value);
    emit('input', false);
}
</script>
